<template>
  <div>
    <ShareModal
      v-if="type === 'shareModal'"
      :name="props.name"
      :shareType="props.shareType"
      :entityId="props.entityId"
      :title="props.title"
      :sharingAccountId="props.sharingAccountId"
      :organizationId="props.organizationId"
      :filters="props.filters"
      @hideModal="hideModal"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ShareModal from '@/containers/Modals/ShareModal.vue'

export default {
  name: 'ModalDispatcher',

  components: {
    ShareModal,
  },

  props: {
    type: {
      type: String,
      required: false,
    },
    props: {
      type: Object,
      required: false,
      default: function() {
        return {}
      },
    },
  },

  methods: {
    ...mapActions({ hideModal: 'modals/hideModal' }),
  },
}
</script>
